import { LIBELLES_TYPE, LIBELLES_STATUT_REPLI, STATUT_META, META_ETAT_LABEL, META_ETAT_BADGE } from './format';
import type { Statut, TypeDemande } from '../../types';
import { useRole } from '../../context/RoleContext';

// Badge de statut : méta-état lisible (gros, coloré) + statut précis en petit
// dessous. Le méta-état donne la compréhension immédiate ("où on en est"), le
// libellé précis (issu de api.getMeta()) apporte le détail. `compact` n'affiche
// que le méta-état (le précis passe en infobulle) pour les contextes serrés.
export function StatutBadge({ statut, libelle, compact, sansInfobulle }: { statut: Statut; libelle?: string; compact?: boolean; /** Vue de la personne : le statut précis (« Soumise », « Brouillon »…) n'est pas pour elle, même en infobulle. */ sansInfobulle?: boolean }) {
  const meta = STATUT_META[statut];
  const metaLabel = META_ETAT_LABEL[meta];
  const metaClass = META_ETAT_BADGE[meta];
  // Repli FR (jamais la valeur brute type "recherche_interne_1") tant que
  // api.getMeta() n'a pas répondu, ou s'il échoue.
  // La recherche élargie (vivier externe) est l'affaire de la gestion :
  // l'intervenant·e lit « élargie par l'équipe gestion », jamais « externe ».
  const { peutGerer } = useRole();
  const precis = !peutGerer && statut === 'recherche_externe'
    ? "Recherche élargie par l'équipe gestion"
    : (libelle ?? LIBELLES_STATUT_REPLI[statut]);

  if (compact) {
    return <span className={metaClass} title={sansInfobulle ? undefined : precis}>{metaLabel}</span>;
  }
  return (
    <span style={{ display: 'inline-flex', flexDirection: 'column', gap: 2, alignItems: 'flex-start' }}>
      <span className={metaClass}>{metaLabel}</span>
      <span className="text-xs text-ink-3">{precis}</span>
    </span>
  );
}

// Badge de type — n'affiche rien pour le flux planifié standard.
export function TypeBadge({ type }: { type: TypeDemande }) {
  if (type === 'planifie') return null;
  return <span className="badge badge-err">{LIBELLES_TYPE[type]}</span>;
}

// Origine d'une demande : on ne marque que l'exception. Une demande saisie à la
// main n'a pas de badge ; une demande créée par l'app à partir d'une absence
// Tipee porte « Repérée dans Tipee » à TOUS les statuts (liste, fiche), pour
// qu'on ne la prenne pas pour une demande saisie par la personne elle-même.
export function OrigineBadge({ source }: { source?: string | null }) {
  if (source !== 'tipee') return null;
  return (
    <span
      className="badge badge-tipee"
      title="Cette demande n'a pas été saisie à la main : l'app l'a créée automatiquement à partir d'une absence enregistrée dans Tipee."
    >
      Repérée dans Tipee
    </span>
  );
}
